import { Alert, Button } from 'antd'
import classNames from 'classnames'
import { ReloadOutlined } from '@ant-design/icons'

import { isForcedErrorRedirect } from '@/utils/handleError'

export const getErrorAlert = ({
	msg,
	className = 'mt-3',
	onRetry,
	retryLabel,
	retryIcon,
	withWrapper = false,
	wrapperClass = '',
	retryBtnProps = {},
} = {}) => {
	if (isForcedErrorRedirect()) return null

	const UI = (
		<Alert
			className={className}
			message={msg || 'Something went wrong. Try again!'}
			showIcon
			type='error'
			action={
				onRetry ? (
					<Button
						size='middle'
						type='primary'
						shape='round'
						icon={retryIcon || <ReloadOutlined />}
						onClick={onRetry}
						{...(retryBtnProps || {})}
					>
						{retryLabel || 'Try Again'}
					</Button>
				) : undefined
			}
		/>
	)

	if (withWrapper) {
		return <div className={classNames('w-full px-3', wrapperClass)}>{UI}</div>
	}

	return UI
}
